/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgJointWithGuarantor = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 12a6 6 0 0 1 5.996 5.775L13 18v4h-2v-4a4 4 0 0 0-7.995-.2L3 18v4H1v-4a6 6 0 0 1 6-6zm8.8 3.4a5.972 5.972 0 0 1 1.194 3.319L17 19v3h-2v-3c0-.791-.229-1.545-.651-2.189l-.148-.21zM21 6v2h2v2h-2v2h-2v-2h-2V8h2V6zm-7.333-1.745a4 4 0 0 1-2.468 6.976l-.199.005v-2a2 2 0 0 0 1.454-3.373l-.121-.118zM7 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgJointWithGuarantor as JointWithGuarantor };
